import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Grid, TextField, Button, CardMedia, Input } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { ChangeEvent, useState } from "react";

const AddRecommendedVenue = () => {
  const navigate = useNavigate();
  const [image, setImage] = useState<string>("");

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Add Venue</h1>
        <p>
          <span
            onClick={() => navigate("/dashboard")}
            style={{ cursor: "pointer" }}
          >
            Dashboard
          </span>{" "}
          -{" "}
          <span
            onClick={() => navigate("/manage-venue-owners")}
            style={{ cursor: "pointer" }}
          >
            Manage Venue
          </span>{" "}
          - Add
        </p>
      </div>
      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group w_100">
              <label>Upload Image</label>
              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="photo" />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="icon-button-file">
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg",
                    }}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      const files = (event.target as HTMLInputElement).files;
                      if (files && files[0].type.includes("image")) {
                        setImage(URL.createObjectURL(files[0]));
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="icon"
                      />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="icon" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>
            <div className="control_group w_50">
              <label>Full Name</label>
              <TextField placeholder="Enter full name" hiddenLabel fullWidth />
            </div>
            <div className="control_group w_50">
              <label>Email Address</label>
              <TextField
                placeholder="Enter email address"
                hiddenLabel
                fullWidth
              />
            </div>
            <div className="control_group w_50">
              <label>Phone Number</label>
              <TextField
                placeholder="Enter phone number"
                hiddenLabel
                fullWidth
              />
            </div>
            <div className="control_group w_50">
              <label>Venue Name</label>
              <TextField placeholder="Enter venue name" hiddenLabel fullWidth />
            </div>
            <div className="control_group w_100">
              <label>Address</label>
              <TextField
                placeholder="Enter address"
                hiddenLabel
                fullWidth
                multiline
                rows={4}
              />
            </div>
          </div>
          <div className="form_btn">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-venue-owners")}
            >
              Save
            </Button>
            <Button
              className="btn btn_secondary"
              onClick={() => navigate("/manage-venue-owners")}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default AddRecommendedVenue;
